import { Routes, RouterModule } from '@angular/router';
import { OrganizationLayoutComponent } from './layout/organization-layout.component';
import { OrganizationAccountsComponent } from './accounts/organization-accounts.component';
import { OrganizationChangeHistoryComponent } from './change-history/organization-change-history.component';
import { OrganizationSettingsComponent } from './settings/organization-settings.component';
import { OrganizationBillingComponent } from './billing/organization-billing.component';
import { OrganizationTeamComponent } from './team/organization-team.component';
import { OrganizationPickerComponent } from './picker/organization-picker.component';

const OrganizationRoutes: Routes = [
  // Organization rpicker
  {
    path: 'org',
    component: OrganizationPickerComponent,
  },
  {
    path: 'orgs',
    component: OrganizationPickerComponent,
  },
  // Organization routes
  {
    path: 'org/:org_id',
    component: OrganizationLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'accounts',
        pathMatch: 'full',
      },
      {
        path: 'home',
        redirectTo: 'accounts',
        pathMatch: 'full',
      },
      {
        path: 'accounts',
        component: OrganizationAccountsComponent,
      },
      {
        path: 'team',
        component: OrganizationTeamComponent,
      },
      {
        path: 'changes',
        component: OrganizationChangeHistoryComponent,
      },
      {
        path: 'billing',
        component: OrganizationBillingComponent,
      },
      {
        path: 'settings',
        component: OrganizationSettingsComponent,
      },
    ],
  },
];

export const OrganizationRouting = RouterModule.forChild(OrganizationRoutes);
